import React, { FunctionComponent, Suspense } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { Application } from '@monorepo/types';
import { CountryCodeType } from './icons-map';
import { getCountryCode, getIconData, isValidCountryCode } from './util';

export interface CountryIconProps extends SvgIconProps {
  code: CountryCodeType;
  project?: Application;
}

export const CountryIcon: FunctionComponent<CountryIconProps> = ({
  code,
  project,
  ...props
}) => {
  const { Icon } = getIconData({ code, project });

  return (
    <Suspense fallback={null}>
      <SvgIcon {...props} component={Icon} />
    </Suspense>
  );
};

export { isValidCountryCode, getCountryCode, getIconData };
export type { CountryCodeType };
